import * as API from "@/services/API";

export default {
  getField() {
    return new Promise((resolve, reject) => {
      API.apiClient
        .get(`/about-us-fields`)
        .then((response) => {
          resolve(response.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  getFieldTeam() {
    return new Promise((resolve, reject) => {
      API.apiClient
        .get(`/about-us-team`)
        .then((response) => {
          resolve(response.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
};
